import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import DrinksScreens from './drinks';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [appetizers, setappetizers] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [dataCarne, setdataCarne] = useState(false);
    const [dataMothers, setDataMothers] = useState(false);
     const [showDrinks, setshowDrinks] = useState(false);




     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
                if (item.id === 462) {
                    setappetizers(item);
                }
                 if (item.id === 469) {
                    setcarnte(item);
                }
                if (item.id === 596) {
                    setDataMothers(item);
                }
            });
      }, [menus]);
    
    
     useEffect(() => {
         if (carnte) {
             carnte.menus.map((item) => {
                 if (item.id === 4375) {
                  setdataCarne(item)
                
               }
           })
       }
     }, [carnte]);
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            getInitData();

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
         <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setShowSpecials(true)
        }} goCategories={setshowCategories}>
                <div>
                    
                    <img
                        style={{
                            width: 490,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: -10,
                            
                        }}
                        src={require('./assets/logo.png')}
                    />


                    <img
                        style={{
                            width: 490,
                            height: 100,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: 40,
                            
                        }}
                        src={require('./assets/menu.png')}
                    />
                
                   
                    <div
                        style={{
                            width: '90%',
                            margin: '14px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            position: 'relative',
                            zIndex: 100
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
                            <img src={require('./assets/rowone/1-PICADERA.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/2-MOFONGOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/3-MARISCOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/4-CARNES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        </div>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                            <img src={require('./assets/rowone/5-ENTRADAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/6-ENSALADAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/7-DESAYUNOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                            <img src={require('./assets/rowone/8-CHOFAN.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        </div>
                    </div>

                   
                </div>
                
                <div style={{ width: '100%', position: 'relative'}}>
                    
                    <img
                        onClick={() => {
                           // setdishs(dataMothers)
                        //setShowListProduct(true)
                        }}
                        src={require('./assets/bannerh.png')}
                       
                        style={{
                        width: '90%',
                        height: 212,
                            borderRadius: 14,
                            objectFit: 'contain',
                            marginTop: 30,
                        marginBottom : 20
                        }}
                    />
                </div>

                <div
                        style={{
                            width: '90%',
                            margin: '20px auto 0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            position: 'relative',
                            zIndex: 100
                        }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
                        <img src={require('./assets/rowone/9-BEBIDAS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/10-SANDWICHES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/11-ACOMPANANTES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/12-COMBOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                        <img src={require('./assets/rowone/13-CAFE.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/14-BATIDOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/15-JUGOS.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                        <img src={require('./assets/rowone/16-POSTRES.png')} style={{ width: '24%', objectFit: 'contain', cursor: 'pointer' }} />
                    </div>
                    </div>

           
            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                   {showDrinks && <DrinksScreens setShowListProduct={setshowDrinks} setShowHappy={setshowCategories} />}
            

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
           
      
            
        </LayoutContent>
        </div>
    );
}

export default Index;